export default __webpack_public_path__ + "media/src/assets/images/excel-dc11605e1b6459600212babd8f34942a.png";